import React, { useContext, useEffect, useState, useRef } from "react";
import "./Historico.scss";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { useAsyncError, useNavigate } from "react-router-dom";
import usePermissoes from "@hooks/usePermissoes";
import Calendario from "@components/calendario/Calendario";
import InputPesquisa from "@components/inputPesquisa/InputPesquisa";
import EndPointServices from "@services/ApiServices";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import Grid from "@components/grid/Grid";
import mappingColumn from "@components/grid/mappingColumn";
import BarChartMixed from "@components/graficos/barchartmixed/BarChartMixed";

const Historico = () => {
  //State Padrões
  const [setLoading] = useLoading();
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  //Loading
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);

  //List
  const [listKey, setListKey] = useState([]);
  const [listValue, setListValue] = useState([]);

  //Date
  const [selectedDate, setSelectedDate] = useState(() => {
    const now = new Date();

    // Data final é o dia de hoje, às 23:59:59.999 (UTC)
    const endDate = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59,
        999,
      ),
    );

    // Data inicial é 30 dias atrás, às 00:00:00.000 (UTC)
    const startDate = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - 29, // -29 para incluir o dia de hoje no total de 30 dias
        0,
        0,
        0,
        0,
      ),
    );

    return [startDate, endDate];
  });

  //RetornoPesquisa
  const [retornoPesquisa, setRetornoPesquisa] = useState(null);
  const [clear, setClear] = useState(false);

  //Grid
  const [dataGrid, setDataGrid] = useState([]);
  const [loadingGrid, setLoadingGrid] = useState(false);

  //Grafico
  const [dadosGrafico, setDadosGrafico] = useState([]);

  //Consultas
  async function handleConsultarFieldHistorico(dados) {
    if (dados?.tp === "key") {
      setLoading1(true);
    }
    if (dados?.tp === "valor") {
      setLoading2(true);
    }

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      tp: dados?.tp,
      ID_Field: dados?.id,
    };

    try {
      var retornoapi = await EndPointServices.CAD_HistoricoFieldConsultar(data);
      if (retornoapi.Success) {
        if (dados?.tp === "key") {
          setListKey(retornoapi?.BaseReturn?.LstClasse);
        } else if (dados?.tp === "valor") {
          setListValue(retornoapi?.BaseReturn?.LstClasse);
        }
      }
    } catch (ex) {
      console.log(ex);
    }

    if (dados?.tp === "key") {
      setLoading1(false);
    }
    if (dados?.tp === "valor") {
      setLoading2(false);
    }
  }
  async function handleConsultarHistorico() {
    setLoadingGrid(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      ...(retornoPesquisa && { Json: retornoPesquisa }),
      ...(selectedDate?.[0] && {
        DataIni: new Date(selectedDate[0]).toISOString().split("T")[0], //necessario esse formato para funcionar em produção
      }),
      ...(selectedDate?.[1] &&
        selectedDate?.[0].toDateString() !==
          selectedDate?.[1].toDateString() && {
          DataFim: new Date(selectedDate[1]).toISOString().split("T")[0], //necessario esse formato para funcionar em produção
        }),
    };

    try {
      var retornoapi = await EndPointServices.CAD_HistoricoConsultar(data);
      if (retornoapi.Success) {
        setDataGrid(retornoapi?.BaseReturn?.LstClasse);

        const agrupado = Object.entries(
          retornoapi?.BaseReturn?.LstClasse?.reduce((acc, item) => {
            if (item.Coluna && item.Valor) {
              var Valor = item.Valor.split(" - ")[0];
              const chave = `${item.Coluna} - ${Valor}`;
              acc[chave] = (acc[chave] || 0) + 1;
            }
            return acc;
          }, {}),
        )
          // Agora sim: ordena pela coluna
          .sort((a, b) => {
            const colunaA = a[0].split(" - ")[0];
            const colunaB = b[0].split(" - ")[0];
            return colunaA.localeCompare(colunaB);
          })
          .map(([chave, total]) => ({
            chave,
            total,
            fill: null,
          }));

        setDadosGrafico(agrupado);
      }
    } catch (ex) {
      console.log(ex);
      setLoadingGrid(false);
    }

    setLoadingGrid(false);
  }
  //Adicionar grafico na lista
  function handleAdicionarLst(dados) {
    setRetornoPesquisa((prevState) => {
      const [coluna, valor] = dados?.chave
        ? dados?.chave.split(" - ")
        : dados?.value.split(" - ");

      let campo = listKey.find((campo) => campo.columnTable === coluna);

      if (!campo) {
        //verificar pelo valor quando a pesquisa é pela coluna.
        campo = listKey.find((campo) => campo.valor === coluna);
        if (!campo) {
          return prevState;
        }
      }

      // Verifica se já existe um item com o mesmo campo e valor
      const jaExiste = prevState.some(
        (item) =>
          item.key?.columnTable === coluna && item.valor?.valor === valor,
      );

      if (jaExiste) {
        // Se já existe, não adiciona
        return prevState;
      }

      // Verifica se já existe um item com o mesmo campo e valor (COLUNA)
      const jaExisteColuna = prevState.some(
        (item) => item.key?.columnTable === null && item.valor?.valor === valor,
      );

      if (jaExisteColuna) {
        // Se já existe, não adiciona
        return prevState;
      }

      const novoItem = {
        key: campo,
        valor: {
          valor: valor,
          ID_Field: campo.ID_Field,
        },
      };

      return [novoItem, ...prevState]; // adiciona no início do array
    });
  }

  useEffect(() => {
    handleConsultarHistorico();
  }, [retornoPesquisa, selectedDate]);

  useEffect(() => {
    let dados = {
      tp: "key",
    };
    handleConsultarFieldHistorico(dados);
  }, []);

  return (
    <div className="historico row">
      <div className="pesquisa">
        <Calendario
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          selectRange
        />
        <div style={{ position: "relative" }}>
          <InputPesquisa
            loading1={loading1}
            loading2={loading2}
            listKey={listKey}
            listValue={listValue}
            handleFunctionKey={handleConsultarFieldHistorico}
            handleFunctionPesquisa={handleConsultarHistorico}
            setRetorno={setRetornoPesquisa}
            clear={clear}
            setClear={setClear}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              position: "absolute",
              right: "-20px",
              top: "0px",
            }}
          >
            <ButtonIcon
              pesquisar
              className="pesquisar-icon"
              titleClear="Pesquisar"
              onPesquisar={() => {
                handleConsultarHistorico();
              }}
            />
            <ButtonIcon
              Clear
              className="clear-icon"
              titleClear="Limpar os filtros"
              onClear={() => {
                setRetornoPesquisa([]);
                setClear(true);
              }}
            />
          </div>
        </div>
      </div>
      <BarChartMixed
        YDataKey="chave"
        BarDataKey="total"
        chartData={dadosGrafico}
        functionClick={handleAdicionarLst}
        BarSize={25}
      />
      <div className="col-12" style={{ marginTop: "30px" }}>
        <Grid
          dadosGrid={dataGrid}
          columns={mappingColumn.getCAD_HistoricoConsultar(dataGrid)}
          {...(dataGrid.length > 0 && {
            pageVisible: true,
          })}
          useMemo={!loadingGrid}
          Loading={loadingGrid}
          pagingStaticSize="5"
        />
      </div>
    </div>
  );
};

export default Historico;
